export const NoData = ({ message = 'No Data Found' }) => (
  <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '16px' }}>
    {message}
  </div>
);
